import React from 'react';
import Container from '../ui/Container';
import Sparkle from '../ui/Sparkle';
import {
  FOOTER_COLUMNS, GROUP, SOCIALS, CONTACT, LOGO,
} from './siteData';

const ICONS = {
  instagram: 'M12 2.2c3.2 0 3.6 0 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.25.07 1.63.07 4.81s0 3.56-.07 4.81c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.25.06-1.63.07-4.85.07s-3.6 0-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 01-1.38-.9 3.7 3.7 0 01-.9-1.38c-.16-.42-.36-1.06-.41-2.23C2.21 15.56 2.2 15.18 2.2 12s0-3.56.07-4.81c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.44 2.21 8.82 2.2 12 2.2zm0 1.8c-3.13 0-3.5.01-4.74.07-.9.04-1.38.19-1.7.32-.43.16-.74.36-1.06.68-.32.32-.52.63-.68 1.06-.13.32-.28.8-.32 1.7-.06 1.24-.07 1.61-.07 4.74s.01 3.5.07 4.74c.04.9.19 1.38.32 1.7.16.43.36.74.68 1.06.32.32.63.52 1.06.68.32.13.8.28 1.7.32 1.24.06 1.61.07 4.74.07s3.5-.01 4.74-.07c.9-.04 1.38-.19 1.7-.32.43-.16.74-.36 1.06-.68.32-.32.52-.63.68-1.06.13-.32.28-.8.32-1.7.06-1.24.07-1.61.07-4.74s-.01-3.5-.07-4.74c-.04-.9-.19-1.38-.32-1.7a2.85 2.85 0 00-.68-1.06 2.85 2.85 0 00-1.06-.68c-.32-.13-.8-.28-1.7-.32C15.5 4.01 15.13 4 12 4zm0 3.06A4.94 4.94 0 1112 17a4.94 4.94 0 010-9.88zm0 1.8a3.14 3.14 0 100 6.28 3.14 3.14 0 000-6.28zm5.14-.94a1.15 1.15 0 110 2.3 1.15 1.15 0 010-2.3z',
  facebook: 'M13.5 21v-8h2.7l.4-3.1h-3.1V7.9c0-.9.25-1.5 1.55-1.5h1.65V3.6c-.8-.1-1.6-.15-2.4-.14-2.37 0-4 1.45-4 4.1V9.9H7.8V13h2.5v8h3.2z',
  youtube: 'M21.6 7.2s-.2-1.36-.8-1.96c-.76-.8-1.6-.8-2-.85C16 4.2 12 4.2 12 4.2h-.01s-4 0-6.8.19c-.4.05-1.24.05-2 .85-.6.6-.8 1.96-.8 1.96S2.2 8.8 2.2 10.4v1.5c0 1.6.2 3.2.2 3.2s.2 1.36.8 1.96c.76.8 1.76.77 2.2.86 1.6.15 6.6.19 6.6.19s4 0 6.8-.19c.4-.05 1.24-.05 2-.85.6-.6.8-1.96.8-1.96s.2-1.6.2-3.2v-1.5c0-1.6-.2-3.21-.2-3.21zM9.9 14.6V8.97l5.15 2.82L9.9 14.6z',
};

const Footer = () => (
  <footer className="bg-ink text-white/60 pt-14 md:pt-20 pb-10" data-testid="marketing-footer">
    <Container>
      <div className="grid gap-14 md:gap-14 md:grid-cols-[minmax(260px,1fr)_2fr] pb-12 border-b border-white/10">
        <div>
          <a href="/" aria-label="Shopstar home" className="inline-block mb-5">
            <img src={LOGO.white} alt="Shopstar" className="h-8 w-auto" />
          </a>
          <p className="max-w-[320px] leading-relaxed text-white/70">
            A place for makers and creators to start, manage and grow successful online stores.
          </p>
          <div className="flex gap-3 mt-6">
            {SOCIALS.map((s) => (
              <a key={s.label} href={s.href} aria-label={s.label} target="_blank" rel="noreferrer"
                className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-white/[0.06] text-white hover:bg-amber hover:text-ink hover:-translate-y-0.5 transition-all">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d={ICONS[s.icon]} /></svg>
              </a>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-8">
          {FOOTER_COLUMNS.map((col) => (
            <div key={col.title}>
              <h4 className="text-white text-xs font-extrabold uppercase tracking-[0.12em] mb-4">{col.title}</h4>
              <ul className="flex flex-col gap-2.5">
                {col.links.map((l) => (
                  <li key={l.label}><a href={l.href} className="text-white/70 hover:text-amber transition-colors">{l.label}</a></li>
                ))}
              </ul>
            </div>
          ))}
          <div>
            <h4 className="text-white text-xs font-extrabold uppercase tracking-[0.12em] mb-4">Say hello</h4>
            <ul className="flex flex-col gap-2.5">
              <li><a href={`mailto:${CONTACT.email}`} className="text-white/70 hover:text-amber transition-colors">{CONTACT.email}</a></li>
              {CONTACT.addressLines.map((line) => <li key={line} className="text-white/40 text-[0.92rem]">{line}</li>)}
            </ul>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-5 flex-wrap py-6 border-b border-white/10">
        <span className="inline-flex items-center gap-2 text-white font-extrabold"><Sparkle size={14} color="#ffb442" /> Shopstar Group</span>
        {GROUP.map((g) => (
          <a key={g.label} href={g.href} target="_blank" rel="noreferrer" className="text-white/70 font-semibold hover:text-amber transition-colors">{g.label}</a>
        ))}
      </div>

      <div className="flex justify-between flex-wrap gap-3 pt-6 text-sm text-white/40">
        <span>© {new Date().getFullYear()} Shopstar PTY LTD. All rights reserved.</span>
        <span>Made with <span className="text-amber">♥</span> in Cape Town.</span>
      </div>
    </Container>
  </footer>
);

export default Footer;
